<template>
  <base-goods-action
    v-model="showGoodsAction"
    ref="goodsAction"
    :enable-coupon="false"
    goods-title="财币充值"
    goods-name-title="账户余额"
    goods-name="1人民币等于1财币"
    goods-list-title="充值金额"
    :goods-list="goodsList"
    :payments="payments"
    :loading="loading"
    @pay="createOrder"
  >
    <template #goods="{goodsItem}">
      <div class="set-name">{{ goodsItem.name }}</div>
    </template>
  </base-goods-action>
</template>

<script>
import { PaymentMethods } from '@/constant/PaymentMethods'
import BaseGoodsAction from '@/components/GoodsAction/BaseGoodsAction'
import { getBalance, getAllFaceValues } from '@/api/vcurrency'
import store from '@/store'

export default {
  name: 'RechargeAction',
  components: { BaseGoodsAction },
  data() {
    return {
      payments: [PaymentMethods.basepayWei, PaymentMethods.BasepayAli],
      payMethod: 0,
      goodsList: null,
      showGoodsAction: false,
      loading: false,
      /**
       * 商品信息
       * @type {GoodsInfo}
       */
      goodsInfo: null,
      /**
       * 订单信息
       * @type {OrderInfo}
       */
      orderInfo: null,
      /**
       * 财币剩余数量
       */
      balance: 0
    }
  },
  created() {
    this.getBalance()
  },
  methods: {
    show(goods) {
      this.goods = goods
      this.showGoodsAction = true

      this.getGoods()
    },
    hide() {
      this.loading = false
      this.showGoodsAction = false
    },
    async getBalance() {
      this.balance = await getBalance()
    },
    async getGoods() {
      console.log('支付方式列表：', this.payments)
      const goodsList = await getAllFaceValues()

      if (goodsList) {
        this.goodsList = goodsList
      }
    },
    /**
     * 创建订单
     * @return {Promise<void>}
     */
    async createOrder(productInfo) {
      const productId = productInfo.id
      this.payMethod = productInfo.payMethod

      store
        .dispatch('cashierDesk/open', {
          orderId: productId,
          payMethod: this.payMethod,
          tradeType: productInfo.tradeType || 3,
          type: 2
        })
        .then(result => {
          console.log('充值结果：', result)
          this.hide()
          if (result) {
          }
        })
      //
      // const { result, detail } = await createRechargeOrder(
      //   productId,
      //   productInfo.payMethod
      // )
      // if (result.code === 0) {
      //   this.orderInfo = detail
      //
      //   this.initiatePayment()
      // } else {
      //   this.loading = false
      // }
    },
    /**
     * 发起支付
     */
    initiatePayment() {}
  }
}
</script>

<style lang="scss" scoped>
.set-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: #262626;
  line-height: 1;

  span {
    color: #046bcc;
  }
}

.price {
  padding-top: 12px;
  font-size: 20px;
  color: #e64c2e;
  line-height: 1;

  .symbol {
    font-size: 16px;
  }
}
</style>
